import {gql} from '@apollo/client'

// Each folder comes with what it holds, below it too, so the drive needn't list every file to say.
// "busy" is whether a file in it, or below it, is still being secured.
export const FOLDERS = gql`
  query Folders {
    folders {
      id
      name
      parentId
      createdAt
      updatedAt
      size
      itemCount
      busy
    }
  }
`
